// CSS Modules - component class name prefix: WorldWideList__

<template>
  <div :class="$style.container">
    <div :class="$style.selects">
      <div class="columns is-multiline">
        <div class="column is-half-tablet is-one-quarter-desktop">
          <FormSelect
            :hasFilter="false"
            v-model="regionSelectValue"
            :label="config.regionLabel"
            :options="regionSelectOptions"
            :initialOption="regionSelectValue"
            @input="updateCountries"
          />
        </div>
        <div class="column is-half-tablet is-one-quarter-desktop">
          <FormSelect
            :key="`countryKey-${regionSelectValue}`"
            :hasFilter="false"
            v-model="countrySelectValue"
            :label="config.countryLabel"
            :options="countrySelectOptions"
            :initialOption="countrySelectValue"
            @input="updateContacts"
          />
        </div>
      </div>
    </div>
    <div class="columns is-multiline">
      <div
        :key="index"
        v-for="(result, index) in contacts"
        class="column is-half-tablet is-one-third-desktop"
      >
        <ListTeaser :result="result" :useForm="useForm" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import FormSelect from "../FormSelect/FormSelect.vue";
import ListTeaser from "../ListTeaser/ListTeaser.vue";
import { regionDataUrl } from "../../shared/globals";

export default {
  name: "WorldWideList",
  components: {
    FormSelect,
    ListTeaser
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    useForm: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      apiData: null,
      contacts: [],
      regionSelectOptions: [],
      regionSelectValue: "",
      countrySelectOptions: [],
      countrySelectValue: "",
      wtTrack: window.wtTrack
    };
  },
  methods: {
    getContacts(url) {
      axios
        .get(url)
        .then(response => (this.contacts = response.data.contacts))
        .catch(error => console.error(error));
    },
    updateContacts(value) {
      this.wtTrack(
        { cat: "SALESBOXCLICK" },
        { inputIdent: `${this.regionSelectValue} - ${value}` }
      );
      this.countrySelectValue = value;

      for (let region of this.apiData.regions) {
        if (region.name === this.regionSelectValue) {
          for (let country of region.countries) {
            if (country.name === value) {
              this.getContacts(country.contacts);
            }
          }
        }
      }
    },
    initApiData(data) {
      this.apiData = data;
      this.regionSelectValue = this.config.currentRegion;
      this.countrySelectValue = this.config.currentCountry;

      for (let region of this.apiData.regions) {
        this.regionSelectOptions.push(region.name);

        if (region.name === this.config.currentRegion) {
          for (let country of region.countries) {
            this.countrySelectOptions.push(country.name);

            if (country.name === this.config.currentCountry) {
              this.getContacts(country.contacts);
            }
          }
        }
      }
    },
    updateCountries(value) {
      this.regionSelectValue = value;

      for (let region of this.apiData.regions) {
        if (region.name === value) {
          this.countrySelectValue = region.countries[0].name;
          this.countrySelectOptions.length = 0;

          for (let country of region.countries) {
            this.countrySelectOptions.push(country.name);
          }
          this.getContacts(region.countries[0].contacts);
        }
      }
    }
  },
  mounted() {
    let dataUrl = "";
    window.regionDataUrl
      ? (dataUrl = window.regionDataUrl)
      : (dataUrl = regionDataUrl);
    axios
      .get(dataUrl)
      .then(response => this.initApiData(response.data))
      .catch(error => console.error(error));
  }
};
</script>

<style module lang="scss">
@import "./WorldWideList.scss";
</style>
